import { ViewResaleAuthorizationWrapper } from '../../components/oldResaleAuth'
import { ViewSentResellerAuthorization } from '../../components/ResellerAuthorizations'
import { useCurrentCloudProvider } from '@labrav/common'
import { useFlag } from '@labrav/flags'
import PartnerProductsWrapper from '../PartnerProductsWrapper'
import ResaleAuthorizationsWrapper from '../ResaleAuthorizationsWrapper'

type ViewProps = {
  crmOpportunityId?: string
  externalBaseURL?: string
  search?: string
}

const HubspotResaleAuthorizationView = ({
  crmOpportunityId,
  externalBaseURL,
  search,
}: ViewProps) => {
  const { flag: hubspotAzureResellerAuthFlag } = useFlag(
    'hubspotAzureResellerAuth'
  )
  const cloudMarketplace = useCurrentCloudProvider()
  const isHubspotAzureResellerAuthEnabled =
    !!hubspotAzureResellerAuthFlag?.value


  if (
    isHubspotAzureResellerAuthEnabled &&
    cloudMarketplace === 'AZURE'
  ) {
    return (
      <ViewSentResellerAuthorization
        crmOpportunityId={crmOpportunityId}
        externalBaseURL={externalBaseURL}
        search={search}
      />
    )
  }

  return (
    <ViewResaleAuthorizationWrapper
      crmOpportunityId={crmOpportunityId}
      externalBaseURL={externalBaseURL}
    />
  )
}

export const ExternalViewResaleAuthorization = () => (
  <PartnerProductsWrapper>
    <ResaleAuthorizationsWrapper>
      {({ crmOpportunityId, externalBaseURL, search }) => (
        <HubspotResaleAuthorizationView
          crmOpportunityId={crmOpportunityId}
          externalBaseURL={externalBaseURL}
          search={search}
        />
      )}
    </ResaleAuthorizationsWrapper>
  </PartnerProductsWrapper>
)
